import { render, staticRenderFns } from "./TooltipButton.vue?vue&type=template&id=649165a3&scoped=true"
import script from "./TooltipButton.vue?vue&type=script&lang=js"
export * from "./TooltipButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649165a3",
  null
  
)

export default component.exports